import { AppEnv } from '@brightdrop/app-config';
import {
  RUM_ALLOWED_TRACING_URL_PATTERNS,
  THIRD_PARTY_EXCLUDED_ACTIVITY_URLS,
} from '@brightdrop/telemetry-client';
import type { RumInitConfiguration } from '@datadog/browser-rum';

const DATADOG_CONFIG = {
  site: 'us3.datadoghq.com',
  service: 'cs-web-app',
  sessionSampleRate: 100,
  // Session replay: 100% in prod only; disabled (0) in non-prod.
  sessionReplaySampleRate: globalThis.appConfig.env === AppEnv.PROD ? 100 : 0,
};

const APP_INSIGHTS_TRACK_URL = 'https://dc.services.visualstudio.com/v2/track';

/* RUM configs */
export const DATADOG_RUM_DEFAULT_CONFIG: RumInitConfiguration = {
  applicationId: globalThis.appConfig.instrumentationAppId,
  clientToken: globalThis.appConfig.instrumentationClientToken,
  site: DATADOG_CONFIG.site,
  service: DATADOG_CONFIG.service,
  env: globalThis.appConfig.instrumentationEnv,
  version: globalThis.appConfig.version,
  sessionSampleRate: DATADOG_CONFIG.sessionSampleRate,
  sessionReplaySampleRate: DATADOG_CONFIG.sessionReplaySampleRate,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  excludedActivityUrls: THIRD_PARTY_EXCLUDED_ACTIVITY_URLS,
  beforeSend: (log) => {
    if ((log.resource as { url: string })?.['url'] === APP_INSIGHTS_TRACK_URL) {
      return false;
    }
    return true;
  },
  // Enable RUM-to-APM trace correlation for BrightDrop / GM Envolve + GM Fleet APIs.
  allowedTracingUrls: RUM_ALLOWED_TRACING_URL_PATTERNS,
  traceContextInjection: 'sampled',
};

/* log configs */
export const DATADOG_LOGS_DEFAULT_CONFIG = {
  clientToken: globalThis.appConfig.instrumentationClientToken,
  site: DATADOG_CONFIG.site,
  service: DATADOG_CONFIG.service,
  env: globalThis.appConfig.instrumentationEnv,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: globalThis.appConfig.version,
  forwardErrorsToLogs: true,
  sessionSampleRate: DATADOG_CONFIG.sessionSampleRate,
};
